<style scoped lang="less">
    @import './choose.less';
    .my-el-dialogs.myChoosePerson .treeBox ul{display: inline-block}
    .my-el-dialogs.myChoosePerson .treeBox ul li{min-width:100%;display: inline-block;padding-left: 16px;height:26px;line-height: 26px;word-break:keep-all;white-space:nowrap;cursor: pointer;}
    .my-el-dialogs.myChoosePerson .treeBox ul .schoolSearch{margin-bottom: 16px;width: 90%;height: 34px}
    .my-el-dialogs.myChoosePerson .treeBox ul li.active{background-color: #f0f7ff;}
    .my-el-dialogs.myChoosePerson .treeBox ul li:hover{background-color: #f0f7ff;}
  </style>
  <style lang="less">
    @import './chooseScoped.less';
  </style>
  <template>
    <el-dialog class="my-el-dialogs myChoosePerson" custom-class="dialog-choose-what" :visible.sync="is_show" :close-on-click-modal="false" :width="configWidth+'px'">
      <div class="choosePersonType">
        <a href="javascript:;" v-for="(showTab,index) in showTab" @click="tabFn(showTab)" :key="index">
            <span v-if="showTab == 'org'" :class="{active:tabPane1}">{{config.orgCaption}}</span>
            <span v-if="showTab == 'school'" :class="{active:tabPane2}">{{config.schoolCaption}}</span>
            <span v-if="showTab == 'social'" :class="{active:tabPane3}">{{config.socialCaption}}</span>
        </a>
      </div>
      <div class="choose_main">
        <div class="choose_right">
          <div class="choose_list" :style="'width:' + (configWidth - 210 -leftWidth) + 'px'">
            <div class="seach_box">
              <template v-if="tabPane1">
                  <inputTree :data="orgData" :chooseobj="chooseobj" @treeFn="treeFn" style="width:200px" :key="treeRefresh"></inputTree>
              </template>
              <template v-if="tabPane2">
                  <el-select v-model="schoolNameListId" filterable placeholder="学校搜索" style="width:200px"  @change="schoollist">
                    <el-option
                      v-for="sl in circleData"
                      :key="sl.id"
                      :label="sl.cnName"
                      :value="sl.id">
                    </el-option>
                  </el-select>
              </template>
              <template v-if="tabPane3">
                  <inputTree :data="socialGroupTree" :chooseobj="chooseobj3" @treeFn="setSocialNode" style="width:200px" :key="socialGroupTree" :defaultProps="socialDefaultProps" placeholder="请选择群组" :isShowBtn="false"></inputTree>
                  <inputTree :data="socialFriendTree" :chooseobj="chooseobj3" @treeFn="setSocialNode" style="width:200px" :key="socialFriendTree" :defaultProps="socialDefaultProps" placeholder="请选择好友组" :isShowBtn="false"></inputTree>
              </template>
              <template v-if="tabPane1 || tabPane2">
                <el-input placeholder="请输入内容" v-model="input5" class="input-with-select" @input="tableQuery.page=1,search" style="width:240px;vertical-align:top;">
                  <el-button slot="append" icon="el-icon-search"  @click="tableQuery.page=1, search()"></el-button>
                </el-input>
              </template>
              <template v-if="tabPane1">
                <el-checkbox v-model="isIncludeChild" @change="handleCheckAllChange" style="margin-top: 8px;margin-left: 10px;">是否包含下级机构
                </el-checkbox>
              </template>
              <template v-if="tabPane1 && isShowMore">
                <div class="more">
                  <a href="javaScript:;" @click="open_close">更多
                    <i class="el-icon-arrow-down" :class="{ 'el-icon-arrow-up':isAs, 'el-icon-arrow-down': !isAs}"></i>
                  </a>
                </div>
              </template>
            </div>
            <template v-if="tabPane1">
              <div class="based_display" :class="{ 'display_no' : isA, 'display': !isA}" style="height: 160px;overflow: auto">
                <el-form>
                  <el-form-item label="学段：" style="margin-bottom: 0">
                    <el-button :type="primary_A" size="small" @click="ck_sectionAll(true)">全部</el-button>
                    <el-button :type="sectionid == sec.key?'primary':'text'" size="small" v-for="(sec,index) in section" :key="sec.key" :id="sec.key" @click="ck_section(sec,index,true)">{{ sec.value }}
                    </el-button>
                  </el-form-item>
                  <el-form-item label="年级：" style="margin-bottom: 0">
                    <el-button :type="primary_B" size="small" @click="ck_gradeAll(true)">全部</el-button>
                    <el-button :type="gradeid == sec.key?'primary':'text'" size="small" v-for="(sec,index) in grade" :key="sec.key" :id="sec.key" @click="ck_grade(sec,index,true)">{{ sec.value }}
                    </el-button>
                  </el-form-item>
                  <el-form-item label="学科：" style="margin-bottom: 0">
                    <template v-if="subject.length!=1">
                      <el-button :type="primary_C" size="small" @click="ck_subjectAll(true)">全部</el-button>
                      <el-button :type="subjectid == sec.key?'primary':'text'" size="small" v-for="(sec,index) in subject" :key="sec.key" :id="sec.key" @click="ck_subject(sec,index,true)">{{ sec.value }}
                      </el-button>
                    </template>
                    <template v-if="subject.length == 1">
                      <el-button type="primary" size="small" v-for="(sec,index) in subject" :key="sec" :id="sec.key" @click="ck_role(sec,index,true)">{{ sec.value }}
                      </el-button>
                    </template>
                  </el-form-item>
                  <el-form-item label="角色：" style="margin-bottom: 0">
                    <template v-if="role.length!=1">
                      <el-button :type="primary_E" size="small" @click="ck_roleAll(true)">全部</el-button>
                      <el-button :type="roleid == sec.key?'primary':'text'" size="small" v-for="(sec,index) in role" :key="sec.key" :id="sec.key" @click="ck_role(sec,index,true)">{{ sec.value }}
                      </el-button>
                    </template>
                    <template v-if="role.length == 1">
                      <el-button type="primary" size="small" v-for="(sec,index) in role" :key="sec.key" :id="sec.key" @click="ck_role(sec,index,true)">{{ sec.value }}
                      </el-button>
                    </template>
                  </el-form-item>
                </el-form>
              </div>
            </template>
            <div class="charater-wrap" id="charater-wrap" v-if="tabPane1 || tabPane2">
              <a href="javascript:;" v-for="(nn,index) in letterList" :key="index" @click="chooseLetter($event,nn)">{{nn}}</a>
            </div>
            <div style="padding: 10px 10px 0px 10px" class="myTable">
              <el-table :data="searchArea.tableData.aaData" v-loading="loading" border element-loading-text="拼命加载中" ref="multipleTable" @select="handleSelectionChange" @select-all="allselect" :height="ht" class="org_table">
                <el-table-column type="selection" width="42px">
                </el-table-column>
                <el-table-column prop="userName" label="姓名" show-overflow-tooltip width="120px">
                </el-table-column>
                <el-table-column v-for="(vv,index) in config.right.waiting.columnList" :prop="vv.displayKey" :key="vv.displayKey" :label="vv.caption" show-overflow-tooltip :width="index == 2?'':'160px'">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="check_info" :style="'width:'+leftWidth+'px'">
            <div class="selected-personnel">已选人员({{personList.length}})
              <i class="el-icon-delete" @click="clearAll"></i>
            </div>
            <ul class="person_list">
              <template v-for="(pn, index) in personList">
                <li>
                  <a href="javascript:;" :title="pn.userName" :key="pn.id">
                    <span>{{pn.userName}}</span>
                    <i class="el-icon-close" @click="unChoose(pn,index)"></i>
                  </a>
                </li>
              </template>
            </ul>
          </div>
          <div class="footer">
              <el-pagination v-if="tabPane1"
                @size-change="orgSizeChange"
                @current-change="tableQuery.page = $event, search()"
                :total="searchArea.tableData.iTotalRecords"
                :page-size="tableQuery.size"
                :current-page="tableQuery.page"
                layout="->, total, sizes, prev, pager, next, jumper">
              </el-pagination>
              <el-pagination v-if="tabPane2"
                @size-change="circleSizeChange"
                @current-change="circleTableQuery.page = $event, search()"
                :total="searchArea.tableData.iTotalRecords"
                :page-size="circleTableQuery.size"
                :current-page="circleTableQuery.page"
                layout="->, total, sizes, prev, pager, next, jumper">
              </el-pagination>
              <el-pagination v-if="tabPane3"
                  @size-change="socialQuery.size = $event, search()"
                  @current-change="socialQuery.page = $event, search()"
                  :total="searchArea.tableData.iTotalRecords"
                  :page-size="socialQuery.size"
                  :current-page="socialQuery.page"
                  layout="->, total, sizes, prev, pager, next, jumper">
              </el-pagination>
            <el-button type="primary" @click="config.confirm(personList),is_show = false">确定(已选{{personList.length}}人)
            </el-button>
            <el-button @click="is_show = false">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </template>
  <script>
import { promises } from 'fs';
    export default {
      data() {
        return {
          schoolNameListId:"",
          schoolSearchs:"",
          initialParamss: [],
          loading: true,
          is_show: false,
          nowLeft: {},
          noAuth: 0,
          currentNode: {},
          input5: "",
          defaultExpandedOrgFirstLeve: [],
          defaultExpandedCircleFirstLeve: [],
          isA: false,
          isAs: false,
          isCutPage: false,
          isIncludeChild: true,
          tableQuery: {
            page: 1,
            size: 10,
            draw: 0,
            filter: {
              gradationId: "",
              //            schoolId:'',
              gradeId: "",
              courseId: "",
              roleCode: "",
              pinYin: "",
              orgId: "",
              keyWord: "",
              isIncludeChild: true
            }
          },
          ht: "460",
          circleTableQuery: {
            page: 1,
            size: 10,
            draw: 0,
            filter: {
              schoolId:'',
              roleCode: "",
              pinYin: "",
              keyWord: "",
              exceptCodes:'',
              showUpperOrg:0
            }
          },
          letterList: [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z"
          ],
          primary_A: "primary",
          primary_B: "primary",
          primary_C: "primary",
          primary_D: "primary",
          primary_E: "primary",
          section: [],
          sectionid: "",
          grade: [],
          gradeid: "",
          subject: [],
          issubject: false,
          subjectid: "",
          pinYin: "",
          groupId: "",
          role: [
            { key: "T", value: "教师" },
            { key: "S", value: "学生" },
            { key: "P", value: "家长" }
          ],
          roleid: "",
          config: {
            caption: "选择控件",
            multi: true,
            confirm: function() {},
            left: [],
            selected: [],
            right: {
              waiting: {
                conditionList: [],
                columnList: []
              },
              selected: {
                getInfoUrl: "",
                conditionList: [],
                columnList: []
              }
            }
          },
          treeDefine: "",
          orgData: [],
          circleData: [],
          searchArea: {
            tableQuery: {
              page: 1,
              size: 10,
              draw: 0,
              order: "",
              filter: {
                isIncludeChild: true,
                keywords: "",
                status: "",
                selected: [],
                orgId: ""
              }
            },
            tableData: {
              aaData: [],
              draw: 0,
              iTotalDisplayRecords: 0,
              iTotalRecords: 0
            }
          },
          resultArea: {
            tableQuery: {
              page: 1,
              size: 10,
              draw: 0,
              order: "",
              filter: {
                isIncludeChild: true,
                keywords: "",
                status: "",
                orgId: ""
              }
            },
            tableData: {
              aaData: [],
              draw: 0,
              iTotalDisplayRecords: 0,
              iTotalRecords: 0
            }
          },
          personList: [],
          selectedData: [],
          selectedAllData: [],
          configWidth:'920',
          leftWidth:'220',
          tabPane1:false,
          tabPane2:false,
          tabPane3:false,
          socialQuery:{
            page:1,
            size:10,
            filter:{
                groupId:'',
                groupType:'',
            }
          },
          socialGroupTree:[],//群组
          socialFriendTree:[],//好友组
          showTab:[],
          isSchoolIdEd:false,
          chooseobj:null,
          chooseobj3:null,//社交关系分组默认选择
          isShowMore:true,//是否显示更多操作
          selectNumLimit:null//限制数量
        };
      },
      created() {
        Array.prototype.unique1 = function() {
          let res = [this[0]];
          for (let i = 1; i < this.length; i++) {
            let repeat = false;
            for (let j = 0; j < res.length; j++) {
              if (this[i].id === res[j].id) {
                repeat = true;
                break;
              }
            }
            if (!repeat) {
              res.push(this[i]);
            }
          }
          return res;
        }; //去重
      },
      methods: {
        schoollist(){
          this.search();
        },
        handleCheckAllChange(v) {
          this.search();
        },
        orgSizeChange(v) {
          let vm = this;
          vm.tableQuery.size = v;
          vm.search();
        },
        circleSizeChange(v) {
          let vm = this;
          vm.circleTableQuery.size = v;
          vm.search();
        },
        setCurrentNode(node) {
          this.currentNode = node;
          this.search();
        },
        treeFn(node){
          let vm = this;
          this.currentNode = node;
          this.search();
        },
        open_close() {
          // 查看更多
          this.isA = !this.isA;
          this.isAs = !this.isAs;
          this.isA ? (this.ht = "308") : (this.ht = "460");
        },
        choose() {},
        ck_section(item, type) {
          let vm = this;
          // 选择学段
          this.sectionid = this.section[type].key;
          this.primary_A = "text";
          this.primary_B = "primary";
          this.primary_C = "primary";
          this.primary_D = "primary";
          this.gradeid = "";
          vm.grades();
        },
        ck_sectionAll(type) {
          let vm = this;
          this.sectionid = "";
          this.primary_A = "primary";
          this.primary_B = "primary";
          this.primary_C = "primary";
          this.primary_D = "primary";
          this.gradeid = "";
          vm.grades();
        },
        ck_grade(item, type) {
          let vm = this;
          // 选择年级
          this.gradeid = this.grade[type].key;
          this.primary_B = "text";
          this.primary_C = "primary";
          vm.subjects();
        },
        ck_gradeAll(type) {
          let vm = this;
          this.gradeid = "";
          this.primary_B = "primary";
          this.primary_C = "primary";
          vm.subjects();
        },
        ck_subject(item, type) {
          // 选择学科
          let vm = this;
          this.subjectid = this.subject[type].key;
          this.primary_C = "text";
          vm.search();
        },
        ck_subjectAll(type) {
          let vm = this;
          this.subjectid = "";
          this.primary_C = "primary";
          vm.search();
        },
        grades() {
          let vm = this;
          let SelectPeopleParam = {
            gradationId: this.sectionid,
            noAuth: vm.noAuth
          };
          http
            .get(InterfacePrefix['platform'] + "/api/selectPeople/getAuthorityGrade", {
              params: SelectPeopleParam
            })
            .then(function(xhr) {
              vm.grade = xhr.data.data;
              vm.subjects();
            });
        },
        subjects() {
          let vm = this;
          let SelectPeopleParam = {
            gradationId: this.sectionid,
            noAuth: vm.noAuth,
            gradeId: this.gradeid
          };
          if (!vm.issubject) {
            http
              .get(InterfacePrefix['platform'] + "/api/selectPeople/getAuthoritySubject", {
                params: SelectPeopleParam
              })
              .then(function(xhr) {
                vm.subject = xhr.data.data;
                vm.search();
              });
          } else {
            vm.search();
          }
        },
        ck_role(item, type) {
          // 选择学段
          let vm = this;
          this.roleid = this.role[type].key;
          this.primary_E = "text";
          vm.search();
        },
        ck_roleAll(type) {
          let vm = this;
          this.roleid = "";
          this.primary_E = "primary";
          vm.search();
        },
        chooseLetter(event,val) {
          let vm = this;
          let _this = $(event.target);
          if (_this.hasClass("active")) {
            vm.pinYin = "";
            _this.removeClass("active")
          } else {
            vm.pinYin = val;
            vm.tableQuery.page = 1
            _this.addClass("active").siblings("a").removeClass("active");
          }
          vm.search();
        },
        unChoose(pn, index) {
          let vm = this;
          let ii = vm.personList[index];
          let n = vm.personList.length;
          for (let j = 0; j < vm.searchArea.tableData.aaData.length; j++) {
            if (ii.id === vm.searchArea.tableData.aaData[j].id) {
              vm.searchArea.tableData.aaData[j].querySelected = false;
              vm.$nextTick(function() {
                vm.$refs.multipleTable.toggleRowSelection(vm.searchArea.tableData.aaData[j], false);
              });
            }
          }
          for (let j = 0; j < n; j++) {//删除缓存结果数据
            if (vm.personList[j].id === ii.id) {
              vm.personList.splice(j, 1);
              n = n - 1;
            }
          }
          let d = vm.selectedData.length;
          for (let g = 0; g < d; g++) {
            //删除中间缓存数据
            if (vm.selectedData[g].id === pn.id) {
              vm.selectedData.splice(g, 1);
              d = d - 1;
            }
          }
        },
        clearAll() {
          let vm = this;
          if (vm.personList.length > 0) {
            vm.selectedData = [];
            vm.personList = [];
            vm.search();
          }
        },
        //查询
        search() {
          let vm = this;
          vm.loading = true;
          if (vm.tabPane1) {
            vm.orgListFn()
          } else if(vm.tabPane2) {
            vm.schoolListFn()
          }else if(vm.tabPane3){
            vm.socialListFn()
          }
        },
        //按组织机构
        orgListFn(){
          let vm = this
          vm.tableQuery.filter.keyWord = vm.input5;
          vm.tableQuery.filter.gradationId = vm.sectionid;
          vm.tableQuery.filter.gradeId = vm.gradeid;
          vm.tableQuery.filter.courseId = vm.subjectid;
          vm.tableQuery.filter.roleCode = vm.roleid;
          vm.tableQuery.filter.pinYin = vm.pinYin;
          vm.tableQuery.filter.orgId = vm.currentNode.id ? vm.currentNode.id : "";
          vm.tableQuery.filter.isIncludeChild = vm.isIncludeChild ? 1 : 0;
          if (vm.initialParamss.length > 0) {
            _.forEach(vm.initialParamss, function(v) {
              _.forIn(v, function(val, key) {
                vm.tableQuery.filter[key] = val;
              });
            });
          }
          let obj = $.extend({}, vm.tableQuery, {
            filter: eduFilterParam(vm.tableQuery.filter)
          });
          http
            .get(InterfacePrefix['platform'] + "/api/selectPeople/query", { params: obj })
            .then(function(xhr) {
              _.each(xhr.data.data.aaData, function(vv) {
                vv.querySelected = false;
                vv.deSelected = false;
              });
              vm.searchArea.tableData = xhr.data.data;
              vm.$nextTick(function() {
                for (let i = 0; i < vm.personList.length; i++) {
                  //回显
                  for (
                    let j = 0;
                    j < vm.searchArea.tableData.aaData.length;
                    j++
                  ) {
                    if (
                      vm.personList[i].id === vm.searchArea.tableData.aaData[j].id
                    ) {
                      vm.searchArea.tableData.aaData[j].querySelected = true;
                      vm.$refs.multipleTable.toggleRowSelection(
                        vm.searchArea.tableData.aaData[j],
                        true
                      );
                    }
                  }
                }
              });
              setTimeout(() => {
                vm.loading = false;
              }, 500);
            });
        },
        //按学校
        schoolListFn(){
          let vm = this
          vm.circleTableQuery.filter.keyWord = vm.input5;
          vm.circleTableQuery.filter.schoolId=vm.schoolNameListId;
          vm.circleTableQuery.filter.roleCode = vm.roleid;
          vm.circleTableQuery.filter.pinYin = vm.pinYin;
          // if (vm.initialParamss.length > 0) {
          //   _.forEach(vm.initialParamss, function(v) {
          //     _.forIn(v, function(val, key) {
          //       vm.circleTableQuery.filter[key] = val;
          //     });
          //   });
          // }
          let obj = $.extend({}, vm.circleTableQuery, {
            filter: eduFilterParam(vm.circleTableQuery.filter)
          });
          http
            .get(InterfacePrefix['platform'] + "/api/selectPeople/query", {
              params: obj
            })
            .then(function(xhr) {
              _.each(xhr.data.data.aaData, function(vv) {
                vv.querySelected = false;
                vv.deSelected = false;
              });
              vm.searchArea.tableData = xhr.data.data;
              vm.$nextTick(function() {
                for (let i = 0; i < vm.personList.length; i++) {
                  //回显
                  for (
                    let j = 0;
                    j < vm.searchArea.tableData.aaData.length;
                    j++
                  ) {
                    if (
                      vm.personList[i].id === vm.searchArea.tableData.aaData[j].id
                    ) {
                      vm.searchArea.tableData.aaData[j].querySelected = true;
                      vm.$nextTick(function() {
                        vm.$refs.multipleTable.toggleRowSelection(
                          vm.searchArea.tableData.aaData[j],
                          true
                        );
                      });
                    }
                  }
                }
              });
              setTimeout(() => {
                vm.loading = false;
              }, 500);
            });
        },
        //社交关系
        socialListFn(){
          let vm = this
          // vm.socialQuery.filter.keyWord = vm.input5;
          let obj = $.extend({}, vm.socialQuery, {
            filter: eduFilterParam(vm.socialQuery.filter)
          });
          http.get(InterfacePrefix['social']+'/groupinfos/userGroups/',{params:obj}).then(function(xhr) {
              _.each(xhr.data.data.aaData, function(vv) {
                vv.querySelected = false;
                vv.deSelected = false;
              });
              vm.searchArea.tableData = xhr.data.data
              vm.$nextTick(function() {
                for (let i = 0; i < vm.personList.length; i++) {
                  //回显
                  for (
                    let j = 0;
                    j < vm.searchArea.tableData.aaData.length;
                    j++
                  ) {
                    if (
                      vm.personList[i].id === vm.searchArea.tableData.aaData[j].id
                    ) {
                      vm.searchArea.tableData.aaData[j].querySelected = true;
                      vm.$nextTick(function() {
                        vm.$refs.multipleTable.toggleRowSelection(
                          vm.searchArea.tableData.aaData[j],
                          true
                        );
                      });
                    }
                  }
                }
              });
              setTimeout(() => {
                vm.loading = false;
              }, 500);
          })
        },
        //全选
        allselect(val) {
          let vm = this;
          let el = true;
          if (val.length > 0) {
            _.each(vm.searchArea.tableData.aaData, function(vv) {
              // vv.querySelected = true;
              vm.handleSelectionChange(val, vv, null);
            });
          } else {
            _.each(vm.searchArea.tableData.aaData, function(vv) {
              // vv.querySelected = false;
              vm.handleSelectionChange(val, vv, null);
            });
          }
        },
        handleSelectionChange(e, v, s) {
          let vm = this;
          let len = e.length
          let checked = e === true ? e : !v.querySelected;
          if(vm.selectNumLimit && len > vm.selectNumLimit){//判断超出限定数量
            vm.$message({
              message: '最多选'+vm.selectNumLimit+'人',
              type: 'warning'
            });
            checked = false
          }

          // if (s) {
          //   s === 1 ? (checked = true) : (checked = false);
          // }
          if (checked) {
            //是否勾选
            for (let j = 0; j < vm.searchArea.tableData.aaData.length; j++) {
              if (v.id === vm.searchArea.tableData.aaData[j].id) {
                vm.searchArea.tableData.aaData[j].querySelected = true;
                vm.$nextTick(function() {
                  vm.$refs.multipleTable.toggleRowSelection(
                    vm.searchArea.tableData.aaData[j],
                    true
                  );
                });
              }
            }
          }
          let list = _.filter(vm.searchArea.tableData.aaData, function(vv) {
            return vv.querySelected;
          });
          if (checked) {
            //是否勾选
            let b = [];
            if (list.length !== 0) {
              let aa = list.length;
              for (let j = 0; j < aa; j++) {
                //合并数据
                vm.selectedData.push(list[j]);
              }
            }
            b = vm.selectedData;
            if (vm.selectedData.length > 1) {
              vm.selectedData = b.unique1();
            } else {
              vm.selectedData = b;
            }
          } else {
            for (let j = 0; j < vm.searchArea.tableData.aaData.length; j++) {
              if (v.id === vm.searchArea.tableData.aaData[j].id) {
                vm.searchArea.tableData.aaData[j].querySelected = false;
                vm.$nextTick(function() {
                  vm.$refs.multipleTable.toggleRowSelection(
                    vm.searchArea.tableData.aaData[j],
                    false
                  );
                });
              }
            }
            let s = vm.selectedData.length;
            for (let h = 0; h < s; h++) {
              //删除中间缓存数据
              if (vm.selectedData[h].id === v.id) {
                vm.selectedData.splice(h, 1);
                s = s - 1;
                h = h - 1;
              }
            }
          }
          if (vm.selectedData.length > 1) {
            vm.personList = vm.selectedData.unique1();
          } else {
            vm.personList = vm.selectedData;
          }
        },
        //tab切换
        tabFn(tabVal){
            let vm = this;
            if(tabVal == 'org'){
                vm.tabPane1 = true;
                vm.tabPane2 = false;
                vm.tabPane3 = false;
                vm.isA ? (vm.ht = "308") : (vm.ht = "460");
                vm.getOrgTreeData()
                vm.isIncludeChild = true;
            }else if(tabVal == 'school'){
                vm.ht = "460";
                vm.tabPane1 = false;
                vm.tabPane2 = true;
                vm.tabPane3 = false;
                vm.getSchoolTreeData()
            }else if(tabVal == 'social'){
                vm.ht = "493";
                vm.tabPane1 = false
                vm.tabPane2 = false
                vm.tabPane3 = true
                vm.getSocialTreeData();
            }
        },
        setSocialNode(node){
          this.chooseobj3 = node
          this.socialQuery.filter.groupType = node.groupType
          this.socialQuery.filter.groupId = node.id
          this.search()
        },
        //展开更多数据，学段、年纪、学科
        groupsFn(){
            let vm = this;
            let SelectPeopleParam = {
                noAuth: vm.noAuth
            };
            http.get(InterfacePrefix['platform'] + "/api/selectPeople/getAuthorityPhase", {params: SelectPeopleParam}).then(function(xhr) {
                vm.section = xhr.data.data;
            });
            http.get(InterfacePrefix['platform'] + "/api/selectPeople/getAuthorityGrade", {params: SelectPeopleParam}).then(function(xhr) {
                vm.grade = xhr.data.data;
            });
            if (!vm.issubject) {
                http.get(InterfacePrefix['platform'] + "/api/selectPeople/getAuthoritySubject", {params: SelectPeopleParam}).then(function(xhr) {
                    vm.subject = xhr.data.data;
                });
            }
        },
        //默认查询
        query() {
            let vm = this;
            if(vm.showTab[0] == 'org'){
              vm.groupsFn()
              vm.getOrgTreeData()
            }
            else if(vm.showTab[0] == 'school'){
              vm.getSchoolTreeData()
            }
            else if(vm.showTab[0] == 'social'){
              vm.getSocialTreeData()
            }
        },
        //按组织选择机构下拉树
        getOrgTreeData() {
          let vm = this;
          let val = vm.treeDefine;
          let orgId = window.appframe.$store.state.userInfo.orgId
          let orgurl = InterfacePrefix['platform'] + "/api/selectPeople/listTree?orgId="+orgId+'&itself=1' //val.orgTreeUrl;
  
          http.get(orgurl).then(function(xhr) {
            vm.orgData = [];
            vm.defaultExpandedOrgFirstLeve = [];
            vm.defaultExpandedOrgFirstLeve.push(xhr.data.data[0].id);
            vm.orgData = xhr.data.data;
            vm.search();
          });

        },
        //按学校选择下拉树
        getSchoolTreeData() {
          let vm = this;
          let val = vm.treeDefine;
          let socialurl = val.socialTreeUrl;
          http.get(socialurl).then(function(xhr) {
              vm.circleData = xhr.data.data;
              if(!vm.isSchoolIdEd){
                vm.schoolNameListId=vm.circleData[0].id;
              }
              vm.search();
          });
        },
        //按学校选择下拉树
        getSocialTreeData() {
          let vm = this
          let userId = window.appframe.$store.state.userInfo.id
          // http.get(InterfacePrefix['social']+'/groupinfos/userGroups/'+userId).then(function(xhr) { 
          //   //默认选中第一个节点
          //     let stemp = null
          //     if(xhr.data.data && xhr.data.data.length > 0){
          //       let temp = xhr.data.data[0]
          //       if(temp.groups.length > 0){
          //         stemp = temp.groups[0]
          //       }else{
          //         stemp = temp
          //       }
          //     }
          //     if(stemp){
          //       vm.socialQuery.filter.groupId = stemp.id
          //       vm.socialQuery.filter.groupType = stemp.groupType
          //       vm.chooseobj3 = stemp
          //     }
          //     vm.socialTree = xhr.data.data
          //     vm.socialListFn()
          // })

          Promise.all([
             http.get(InterfacePrefix['social']+'/groupinfos/userGroups/'+userId+'?groupType=1'),//群组
             http.get(InterfacePrefix['social']+'/groupinfos/userGroups/'+userId+'?groupType=2')//好友组
          ]).then(function(list){
              vm.socialGroupTree = list[0].data.data[0].groups
              vm.socialFriendTree = list[1].data.data[0].groups
              let stemp = ''
              for(let i=0;i<list.length;i++){
                let temp = list[i].data.data[0].groups
                if(temp && stemp == ''){
                  stemp = temp[0]
                  vm.socialQuery.filter.groupId = stemp.id
                  vm.socialQuery.filter.groupType = stemp.groupType
                  vm.chooseobj3 = stemp
                }
              }
              vm.socialListFn()
          })
        }
      },
      computed: {
        orgDefaultProps() {
          return {
            children: "children",
            label: this.nowLeft.displayKey
          };
        },
        circleDefaultProps() {
          return {
            children: "children",
            label: this.nowLeft.displayKeys
          };
        },
        socialDefaultProps(){
            return {
                children: "groups",
                label: this.nowLeft.displayKeys
            }
        }
      },
      watch: {
        nowLeft(val) {
          let vm = this;
          vm.treeDefine = val
          vm.query();
        },
        config(val) {
            let vm = this;
            vm.personList = [];
            _.each(val.seletedData, function(vv) {
                vv.querySelected = true;
            });
            vm.noAuth = val.noAuth;
            vm.personList = val.seletedData;
            vm.selectedData = val.seletedData;
            vm.initialParamss = val.initialParams;
            if(vm.initialParamss){
              for(let i=0;i<vm.initialParamss.length;i++){
                if(vm.initialParamss[i].schoolId){
                  vm.schoolNameListId = vm.initialParamss[i].schoolId
                  vm.isSchoolIdEd = true
                }else if(vm.initialParamss[i].exceptCodes){
                  vm.circleTableQuery.filter.exceptCodes =  vm.initialParamss[i].exceptCodes
                }else if(vm.initialParamss[i].showUpperOrg){
                  vm.circleTableQuery.filter.showUpperOrg =  vm.initialParamss[i].showUpperOrg
                }
              }
            }
          
            if(val.width){
                vm.configWidth = val.width
            }
            if(val.leftWidth){
                vm.leftWidth = val.leftWidth
            }
            let showTab = []
            if(val.showtab != ''){
                showTab = val.showtab
            }else{
                showTab = ['org','school','social']
            }
            if(showTab[0] == 'org'){
                vm.tabPane1 = true
            }else if(showTab[0] == 'school'){
                vm.tabPane2 = true
            }else if(showTab[0] == 'social'){
                vm.tabPane3 = true
            }
            vm.showTab = showTab
            vm.subject = val.subject;
            if (val.subject.length === 1) {
              vm.subjectid = val.subject[0].key;
              vm.issubject = true;
            } else {
              vm.subjectid = "";
              vm.issubject = false;
            }
            vm.role = val.role;
            if (val.role.length === 1) {
              vm.roleid = val.role[0].key;
            } else {
              vm.roleid = "";
            }
            //重置table高度
            this.isA ? (this.ht = "308") : (this.ht = "460");
            if(vm.tabPane3 && this.isA){
            this.ht = "520"
            }
            //是否清空筛选条件
            vm.isEmptyFilter = val.isEmptyFilter
            this.nowLeft = val.left[0];

            //选择数量限制
            vm.selectNumLimit = val.selectNumLimit

            vm.isShowMore = val.isShowMore
        },
        is_show(val) {
          let vm = this;
          if (val) {
            this.searchArea = {
              tableQuery: {
                page: 1,
                size: 10,
                draw: 0,
                order: "",
                filter: {
                  isIncludeChild: true,
                  keywords: "",
                  status: "",
                  selected: [],
                  orgId: ""
                }
              },
              tableData: {
                aaData: [],
                draw: 0,
                iTotalDisplayRecords: 0,
                iTotalRecords: 0
              }
            };
            this.resultArea = {
              tableQuery: {
                page: 1,
                size: 10,
                draw: 0,
                order: "",
                filter: {
                  isIncludeChild: true,
                  keywords: "",
                  status: "",
                  orgId: ""
                }
              },
              tableData: {
                aaData: [],
                draw: 0,
                iTotalDisplayRecords: 0,
                iTotalRecords: 0
              }
            };
            let ids = this.config.selected.map(function(vv) {
              return vv.id;
            });
            ids.length &&
            http
              .post(this.config.right.selected.getInfoUrl, ids)
              .then(function(xhr) {
                // vm.resultArea.tableData = xhr.data.data
                vm.resultArea.tableData.iTotalRecords = xhr.data.data.length;
                vm.resultArea.tableData.aaData = xhr.data.data;
              });
          }else{
            if(vm.isEmptyFilter){//是否清空筛选条件
              vm.input5 = "";
              vm.sectionid = "";
              vm.gradeid = "";
              vm.subjectid = "";
              vm.roleid = "";
              vm.pinYin = "";
              vm.currentNode.id = "";
              vm.isIncludeChild = true;
              vm.schoolNameListId = ''

              vm.contactQuery.filter.groupId = ''
              vm.contactQuery.filter.groupType = ''
              this.isA = false
            }
            vm.tabPane1 = false
            vm.tabPane2 = false
            vm.tabPane3 = false
          }
        }
      }
    };
  </script>
  


// WEBPACK FOOTER //
// src/commonplugin/choose/chooseWhats.vue